module.exports = __webpack_public_path__ + "static/media/medin.050dfee1.png";